import { useEffect } from 'react';

export const useAdbobeTacking = ({ trackingId }) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.src = `//assets.adobedtm.com/6677ad16b0484ad2b930d0b209e41c1e96798d52/satelliteLib-${trackingId}.js`;
    head.appendChild(script);
    script.onload = () => {
      try {
        window._satellite.pageBottom();
      } catch (err) {
        console.log(err);
      }
    };
  }, []);
};
